// @packages
import React from 'react';
import { Amplify } from 'aws-amplify';
import { NativeRouter } from 'react-router-native';
import { RootSiblingParent } from 'react-native-root-siblings';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { ThemeProvider } from '@rneui/themed';

// @scripts
import { LogBox } from 'react-native';
import RouterMapper from './src/core/routes';
import initializeApp from './src/core';
import theme from './src/styles/theme';
import { AuthProvider } from './src/core/context/provider';
import { SiteProvider } from './src/core/context/siteProvider';
import config from './src/aws-exports';

Amplify.configure(config);
LogBox.ignoreAllLogs();

export default function App() {
  initializeApp();

  return (
    <SafeAreaProvider>
      <RootSiblingParent>
        <ThemeProvider theme={theme}>
          <NativeRouter>
            <AuthProvider>
              <SiteProvider>
                <RouterMapper />
              </SiteProvider>
            </AuthProvider>
          </NativeRouter>
        </ThemeProvider>
      </RootSiblingParent>
    </SafeAreaProvider>
  );
}
